
import { configuredAxios as api } from './axiosConfig';

// Operações com texto (sem alterações)
const get = (championshipId) => api.get(`/regulations/${championshipId}`).then(res => res.data);
const save = (championshipId, data) => api.put(`/regulations/${championshipId}`, data).then(res => res.data);

// ✅ FUNÇÃO getPdf CORRIGIDA
// Agora ela espera um JSON e retorna a URL diretamente
const getPdf = async (championshipId) => {
  try {
    // A requisição agora é uma chamada de API normal, sem 'responseType: blob'
    const response = await api.get(`/regulations/${championshipId}/pdf`);
    
    // A resposta do backend agora é { success: true, pdfUrl: 'https://...' }
    // Retornamos o objeto inteiro ou apenas a URL, dependendo da necessidade.
    // Retornar o objeto é mais robusto.
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar PDF:', error);
    
    // Se for erro 404 (PDF não encontrado), retornar objeto com success: false
    if (error.response?.status === 404) {
      return { 
        success: false, 
        error: error.response?.data?.error || 'PDF não encontrado' 
      };
    }
    
    // Para outros erros
    throw error;
  }
};

// Operações de upload e delete (sem alterações)
const uploadPdf = (championshipId, formData) => api.post(
  `/regulations/${championshipId}/pdf`,
  formData,
  {
    headers: { 'Content-Type': 'multipart/form-data' }
  }
).then(res => res.data);

const deletePdf = (championshipId) => api.delete(`/regulations/${championshipId}/pdf`).then(res => res.data);

export default { get, save, getPdf, uploadPdf, deletePdf };
